import React from 'react';
import { GrInstagram } from "react-icons/gr";
import { RxDiscordLogo } from "react-icons/rx";
import { RiTwitterXLine } from "react-icons/ri";

const Hero2 = () => {
  return (
    <>
    <div className="flex items-center flex-row justify-center max-w-[800px] py-4  mx-auto mt-[100px] border-[#C0392B] rounded-lg shadow-[#C0392B] shadow-2xl text-white"
    data-aos="fade-up" 
    data-aos-duration="2000" 
    data-aos-delay="1000" 
    >
        <div className="flex flex-col justify-center items-start p-4 text-left md:mr-[80px]">
            <p className='text-[#C0392B] text-2xl md:text-4xl'>80+</p>
            <p className='text-md md:text-x text-white  mt-2'>Project Completed</p>
        </div>
        <div className="w-px bg-gray-300"></div>
        <div className="flex flex-col justify-center items-start p-4 text-left md:ml-[50px] md:mr-[120px]">
            <p className='text-[#C0392B] text-2xl md:text-4xl'>30+</p>
            <p className='text-md md:text-x text-white mt-2'>Happy client</p>
        </div>
        <div className="w-px bg-gray-300"></div>
        <div className="flex flex-col justify-center items-start p-4 text-left md:ml-[50px] ">
            <p className='text-[#C0392B] text-2xl md:text-4xl'>99+</p>
            <p className=' text-md md:text-xl text-white mt-2'>Review Given</p>
        </div>
     </div>
      <div className='max-w-[800px] flex justify-center items-center space-x-[70px]  mt-12 mx-auto'>
            <a href="https://www.instagram.com/ksy_edit/"><GrInstagram  className='text-white text-4xl hover:text-[#C0392B]'/></a>
            <a href=""><RxDiscordLogo className='text-white text-4xl hover:text-[#C0392B]' /></a>
            <a href="https://x.com/ksy_thumbnails"><RiTwitterXLine className='text-white text-4xl hover:text-[#C0392B]' /></a>
      </div>
    
    </>
  );
};

export default Hero2;
